import camelCase from 'lodash.camelcase';

const requireModule = require.context('./', false, /\.ts$/);
const modules: any = {};

requireModule.keys().forEach((fileName: any) => {
  if (fileName === './timeline.ts') {
    return;
  }

  const moduleName = camelCase(
    fileName.replace(/(\.\/|\.ts)/g, '')
  );
  const module = requireModule(fileName);

  modules[moduleName] = module.default || module;
});

export default modules;
